import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { mobile, tablet } from '~styles/global'
import { Star } from '~components/Svg'
import Section from '~components/Section'

const Divider = ({ className }) => {
	return (
		<Wrap className={className}>
			<Row>
				<Line/>
				<StarIcon />
				<Line/>
			</Row>
		</Wrap>
	)
}

const Wrap = styled(Section)`
`
const Row = styled.div`
	grid-column: span 12;
	height: 54px;
	display: flex;
	align-items: center;
	justify-content: center;
`
const StarIcon = styled(Star)`
	width: 36px;
	margin: 0 var(--m);
	${tablet}{
		width: 28px;
	}
`
const Line = styled.div`
	height: 1px;
	flex: 1;
	background-color: var(--white);
	max-width: 532px;
`

Divider.propTypes = {
	className: PropTypes.string
}

export default Divider